var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 380,
    height: 160,
    viewBox: "0 0 380 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7378",
    "data-name": "Rectangle 7378",
    width: 380,
    height: 160,
    transform: "translate(726 421)",
    fill: "#efefef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock_card",
    "data-name": "lock card",
    transform: "translate(-726 -421)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28141",
    "data-name": "Group 28141",
    transform: "translate(-21.744 42.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28141-2",
    "data-name": "Group 28141",
    transform: "translate(2643.959 5278.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28133",
    "data-name": "Group 28133",
    transform: "translate(-1730.959 -4888.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28127",
    "data-name": "Group 28127",
    transform: "translate(7.147 31.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31256",
    "data-name": "Path 31256",
    d: "M-1722.76-4862.117l5.6,3.28,8.674,5.078a4.164,4.164,0,0,1,1.827,3.309l-.1,10.375c.022,1.224-.813,1.728-1.864,1.149l-14.266-8.354a4.146,4.146,0,0,1-1.827-3.309l.056-6.637.032-3.743C-1724.638-4862.185-1723.8-4862.7-1722.76-4862.117Z",
    transform: "translate(1724.714 4862.357)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28128",
    "data-name": "Group 28128",
    transform: "translate(0 35.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31257",
    "data-name": "Path 31257",
    d: "M-1683.028-4842.25l-2.891,4.1,21.662,56.187-62.914-36.324a8.353,8.353,0,0,1-3.788-6.561l.079-27.651a19.7,19.7,0,0,1,7.126-5.166l-.056,6.637a4.15,4.15,0,0,0,1.827,3.31l14.266,8.353c1.052.578,1.886.073,1.864-1.149l.1-10.376a4.163,4.163,0,0,0-1.827-3.309l-8.674-5.078c5.578-.2,11.92,1.524,18.644,5.405A67.515,67.515,0,0,1-1683.028-4842.25Z",
    transform: "translate(1730.959 4859.296)",
    fill: "#f79d50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28129",
    "data-name": "Group 28129",
    transform: "translate(48.017 35.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31258",
    "data-name": "Path 31258",
    d: "M-1639.958-4837.142a8.332,8.332,0,0,1,2.14,5.179l-.182,64.253a4.531,4.531,0,0,1-.046.641,3.521,3.521,0,0,1-.069.348,2.779,2.779,0,0,1-.308.761,2.1,2.1,0,0,1-.194.273c-.68.809-1.856.923-3.2.149l-22.1-12.759c.073-.672.131-1.359.177-2.055.016-.239.023-.354.028-.471.018-.338.026-.493.032-.651q.008-.164.014-.328c0-.075.006-.152.008-.229,0-.1.007-.21.009-.316,0-.073,0-.146.006-.219,0-.122,0-.242.007-.363.006-.362.007-.544.007-.728.076-10.3-2.789-21.749-7.852-32.65A95.738,95.738,0,0,0-1689-4842.19l11.779-16.9,35.62,20.565a5.76,5.76,0,0,1,.579.384c.126.1.249.2.371.3A7.809,7.809,0,0,1-1639.958-4837.142Z",
    transform: "translate(1689.004 4859.088)",
    fill: "#0f1c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28130",
    "data-name": "Group 28130",
    transform: "translate(45.04 52.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31259",
    "data-name": "Path 31259",
    d: "M-1688.714-4844.4a97.045,97.045,0,0,1,17.615,25.973c5.063,10.9,7.928,22.351,7.852,32.65q0,.275,0,.546c0,.061,0,.121,0,.181,0,.121,0,.242-.007.363,0,.074,0,.146-.006.22,0,.105-.006.212-.009.316,0,.076,0,.153-.008.229,0,.109-.008.218-.014.327-.007.157-.014.314-.022.47,0,.061-.007.121-.01.182q-.009.174-.021.347c-.054.818-.113,1.5-.188,2.178l-6.406-3.7L-1691.6-4840.3Z",
    transform: "translate(1691.605 4844.401)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28131",
    "data-name": "Group 28131",
    transform: "translate(1.291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31260",
    "data-name": "Path 31260",
    d: "M-1627.28-4830.177l-.17,64.247a4.918,4.918,0,0,1-.053.644,2.789,2.789,0,0,1-.066.344,2.674,2.674,0,0,1-.316.762,2.962,2.962,0,0,1-.184.277,1.829,1.829,0,0,1-.5.409l-3.647,2.121-.014.013-.974.567a1.689,1.689,0,0,0,.488-.422,1.228,1.228,0,0,0,.2-.264,2.663,2.663,0,0,0,.3-.764,2.683,2.683,0,0,0,.079-.342,5.1,5.1,0,0,0,.04-.646l.183-64.258a8.4,8.4,0,0,0-2.133-5.175,8.57,8.57,0,0,0-.7-.7c-.132-.105-.251-.2-.382-.3-.184-.132-.382-.265-.579-.382l-35.619-20.568-55.793-32.208a2.689,2.689,0,0,0-2.712-.264l.974-.566,3.674-2.133a2.662,2.662,0,0,1,2.7.263l55.806,32.222,35.62,20.555c.2.119.381.25.578.4a3.744,3.744,0,0,1,.37.3,8.6,8.6,0,0,1,.7.685A8.353,8.353,0,0,1-1627.28-4830.177Z",
    transform: "translate(1729.831 4890.047)",
    fill: "#f5f8ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28132",
    "data-name": "Group 28132",
    transform: "translate(0.079 2.695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31261",
    "data-name": "Path 31261",
    d: "M-1723.764-4853.564a19.708,19.708,0,0,0-7.126,5.166l.1-36.6c.007-2.415,1.719-3.381,3.812-2.172l55.8,32.216-11.865,16.81a67.524,67.524,0,0,0-14.585-11.625c-6.724-3.881-13.066-5.607-18.644-5.406l-5.6-3.279c-1.043-.583-1.878-.067-1.864,1.15Z",
    transform: "translate(1730.89 4887.692)",
    fill: "#1952a1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19041",
    "data-name": "Group 19041",
    transform: "translate(858.646 461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19040",
    "data-name": "Group 19040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19030",
    "data-name": "Group 19030",
    transform: "translate(7.087 4.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29707",
    "data-name": "Path 29707",
    d: "M-10486.279,781.777c-.039-.056-.082-.112-.125-.166s-.077-.089-.118-.134c-.066-.075-.133-.149-.2-.221-.043-.048-.1-.1-.144-.142s-.1-.094-.146-.143a9.243,9.243,0,0,0-1.632-1.187,17.873,17.873,0,0,0-16.225,0,7.712,7.712,0,0,0-2.5,2.186c-.051.074-.1.149-.149.227a.481.481,0,0,1-.043.069l-.05.082a4.927,4.927,0,0,0-.262.531.467.467,0,0,0-.037.09,3.958,3.958,0,0,0-.292,1.489,5.163,5.163,0,0,0,2.341,4.03,10.272,10.272,0,0,1,.962-.638,17.888,17.888,0,0,1,16.228,0,9.815,9.815,0,0,1,1.044.693,5.16,5.16,0,0,0,2.363-4.028A4.4,4.4,0,0,0-10486.279,781.777Z",
    transform: "translate(10508.206 -777.837)",
    fill: "#121b45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19031",
    "data-name": "Group 19031",
    transform: "translate(34.234 10.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29708",
    "data-name": "Path 29708",
    d: "M-10483.764,783.355c0,.059-.007.111-.007.166-.008.126-.019.245-.033.365-.009.087-.021.173-.035.259-.009.045-.016.089-.022.134a8.09,8.09,0,0,1-2.387,4.24c-.11.117-.225.222-.342.33l2.806,1.62.021-7.284C-10483.762,783.244-10483.764,783.3-10483.764,783.355Z",
    transform: "translate(10486.59 -783.186)",
    fill: "#ff9f41"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_166",
    "data-name": "Union 166",
    d: "M-10450.593,820.356l6.975-4.052-35.13-20.282-.879-.51-5.725-3.3-.024,8.067Zm-57.789-21.567a26.807,26.807,0,0,0,13.112,3.147,29.063,29.063,0,0,0,9.891-1.656l.023-8.067c-7.145,2.622-16.74,2.128-23-1.49-3.643-2.1-5.467-4.864-5.467-7.623l-.024,8.048c-.009,2.763,1.815,5.526,5.467,7.636Z",
    transform: "translate(10513.85 -772.404)",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_167",
    "data-name": "Union 167",
    d: "M-10449.942,830.788h0l14.827-8.614.025-8.069-12.034,6.994-2.795,1.624h0l-3.474-2.01v.8l-.021,7.262Zm-10.482-6.052h0l6.279-3.642.022-8.067-1.971,1.142-2.2,1.276-2.111,1.227h0l-4.757-2.747-.021,8.067Zm7.039-3.215v-.8l6.279-3.65-7.008-4.041-.026,8.06Z",
    transform: "translate(10526.304 -764.746)",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19039",
    "data-name": "Group 19039",
    transform: "translate(0.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29716",
    "data-name": "Path 29716",
    d: "M-10422.645,823.954l-12.032,7-2.795,1.623-3.473-2.009,6.28-3.65-7.01-4.047-1.967,1.143-2.2,1.276-2.109,1.227-4.759-2.747,2.111-1.226,6.977-4.054-35.132-20.282-.877-.51-5.729-3.3c-7.142,2.622-16.738,2.128-23-1.489-3.64-2.1-5.467-4.864-5.467-7.623,0-2.734,1.79-5.467,5.381-7.552,7.209-4.19,18.938-4.19,26.2,0,3.656,2.114,5.483,4.892,5.464,7.661v.166c0,.059-.007.111-.007.166-.007.125-.02.244-.033.364-.011.085-.022.172-.034.257l-.023.134a8.087,8.087,0,0,1-2.388,4.24c-.11.116-.225.221-.344.329l2.81,1.621Zm-63.557-34.576a5.172,5.172,0,0,0,2.369-4.035,4.436,4.436,0,0,0-1-2.737c-.043-.059-.095-.124-.131-.164s-.075-.088-.115-.136c-.068-.073-.131-.148-.2-.221-.048-.047-.1-.094-.146-.142l-.148-.143a9.3,9.3,0,0,0-1.638-1.187,17.88,17.88,0,0,0-16.224,0,7.684,7.684,0,0,0-2.5,2.186c-.054.075-.1.151-.149.227l-.044.069-.049.082a4.791,4.791,0,0,0-.263.532l-.036.092a4.037,4.037,0,0,0-.291,1.49,5.163,5.163,0,0,0,2.342,4.029,9.323,9.323,0,0,0,1.041.692,17.879,17.879,0,0,0,16.224,0,10.388,10.388,0,0,0,.97-.639Z",
    transform: "translate(10513.828 -774.584)",
    fill: "#ff9f41"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCard);
export default __webpack_public_path__ + "static/media/lock_card.e3faf71d5ba86baea95d00f37ac661ca.svg";
export { ForwardRef as ReactComponent };